// Preserve synchronous local previews while awaiting database confirmation in the portal.
export const settleCRM = (result, complete) => result && typeof result.then === 'function' ? result.then(complete) : complete(result);
export async function fetchCRM(workspace = 'live') {
    const { default: api } = await import('./api');
    return (await api.get('/crm', { timeout: 20000, params: { workspace } })).data;
}
export async function sendCRM(revision, command, workspace = 'live') {
    const { default: api } = await import('./api');
    return (await api.post('/crm/actions', { revision, command }, { timeout: 20000, params: { workspace } })).data;
}
export async function requestCRMImport(phase, values, workspace) {
    const { default: api } = await import('./api');
    return (await api.post(`/crm/imports/${phase}`, values, { timeout: 60000, params: { workspace } })).data;
}
